import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Terminal from "./pages/Terminal";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Account from "./pages/Account";
import AdminSupport from "./pages/AdminSupport";
import { AuthProvider } from "./contexts/AuthContext";
import SupportWidget from "./components/SupportWidget";
import { initPostHog, trackPageView } from "./lib/analytics";

// Initialize PostHog on app load
initPostHog();

// Component to track page views on route change
function PageViewTracker() {
  const location = useLocation();
  
  useEffect(() => {
    const pageName = location.pathname === '/' ? 'home' : location.pathname.slice(1);
    trackPageView(pageName);
  }, [location.pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PageViewTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terminal" element={<Terminal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin/support" element={<AdminSupport />} />
          </Routes>
          <SupportWidget />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
